import { IAcknowledgementPostTitle } from "./AcknowledgementPostTitle/AcknowledgementPostTitle";
import { ICommentLikeTitle } from "./CommentLikeTitle/CommentLikeTitle";
import { ICommentPostTitle } from "./CommentPostTitle/CommentPostTitle";
import { ICommentReplyTitle } from "./CommentReplyTitle/CommentReplyTitle";
import { IContentLikeTitle } from "./ContentLikeTitle/ContentLikeTitle";
import { IContentPostTitle } from "./ContentPostTitle/ContentPostTitle";
import { IModeratedCommentTitle } from "./ModeratedCommentTitle/ModeratedCommentTitle";
import { IRecognitionPostTitle } from "./RecognitionPostTitle/RecognitionPostTitle";

export function getAcknowledgementPostTitle({content, user, isPopOut}: IAcknowledgementPostTitle ) {
    const className: string =  isPopOut ? "acknowledgement-response-information" : "acknowledgement-response-information-full acknowledgement-response-information"
    const contentLinkAriaLabel = `Visit ${content.title}`;
    const contentLink = content.link;
    const contentLinkTitle = content.title;
    const activityInformation : string = `${user} responded to `;

    return {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle}
};

export function getCommentLikeTitle({user, commentAuthor, isPopOut}: ICommentLikeTitle ) {
    const className: string =  isPopOut ? "comment-notification-information" : "comment-notification-information-full comment-notification-information"
    const activityInformation : string = `${user} liked a comment by ${commentAuthor ?? "Unknown"}`;

    return {className, activityInformation}
};

export function getCommentPostTitle({content, user, isPopOut}: ICommentPostTitle ) {
    const className: string =  isPopOut ? "comment-notification-information" : "comment-notification-information-full comment-notification-information"
    const contentLinkAriaLabel = `Visit ${content.title}`;
    const contentLink = content.link;
    const contentLinkTitle = content.title
    const activityInformation : string = `${user} commented on `;

    return {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle}
};

export function getCommentReplyTitle({content, user, commentAuthor, isPopOut}: ICommentReplyTitle ) {
    const className: string =  isPopOut ? "comment-reply-notification-information" : "comment-reply-notification-information-full comment-reply-notification-information"
    const contentLinkAriaLabel = `Visit ${content.title}`;
    const contentLink = content.link;
    const contentLinkTitle = content.title
    const activityInformation : string = `${user} replied to ${commentAuthor ?? "Unknown"}'s comment on  `;

    return {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle}
}; 

export function getContentLikeTitle({user, contentAuthor, isPopOut}: IContentLikeTitle ) {
    const className: string =  isPopOut ? "content-like-information" : "content-like-information-full content-like-information"
    const activityInformation : string = `${user} liked the post by ${contentAuthor ?? "Unknown"}`;

    return {className, activityInformation}
};

export function getContentPostTitle({parentList, user, isPopOut}: IContentPostTitle ) {
    const className: string =  isPopOut ? "content-posted-information" : "content-posted-information-full content-posted-information"
    const contentLinkAriaLabel = `Visit ${parentList?.title}`;
    const contentLink = parentList?.link;
    const contentLinkTitle = parentList?.title ?? `an Archived List`
    const activityInformation : string = `${user} posted in `;

    return {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle}
};

export function getModeratedCommentTitle({content, commentAuthor, userWhoFlagged, isPopOut}: IModeratedCommentTitle ) {
    const className: string =  isPopOut ? "comment-notification-information" : "comment-notification-information-full comment-notification-information"
    const contentLinkAriaLabel = `Visit ${content.title}`;
    const contentLink = content.link;
    const activityInformation: { part1: string; part2: string } = {
        part1: `${commentAuthor}'s comment on `,
        part2: ` was flagged by ${userWhoFlagged}`,
    };
    const contentLinkTitle = content.isArchived
        ? `${content.title} (Archived)`
        : `${content.title}`;

    return {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle}
};

export function getRecognitionPostTitle({user, recognisedUser, parentList, isPopOut}: IRecognitionPostTitle ) {
    const className: string =  isPopOut ? "recognition-post-information" : "recognition-post-information-full recognition-post-information"
    const hasContentLink : boolean = !!parentList;
    const activityInformation : string = hasContentLink ? `${user} recognised ${recognisedUser} on ` : `${user} recognised ${recognisedUser}`;
    const contentLink = parentList?.link;
    const contentLinkTitle = parentList?.title;
    const contentLinkAriaLabel = `Visit ${parentList?.title}`;

    return {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle, hasContentLink}
};

export function getFormResponseTitle({user, isPopOut}: IContentPostTitle ) {
    const className: string =  isPopOut ? "content-posted-information" : "content-posted-information-full content-posted-information"
    const activityInformation : string = `${user} submitted a form response `;

    return {className, activityInformation}
};

export function getPasskeyResetTitle({user, isPopOut}: IContentPostTitle ) {
    const className: string =  isPopOut ? "passkeys-reset-information" : "passkeys-reset-information-full passkeys-reset-information"
    const activityInformation : string = `${user} requested an account recovery code `;

    return {className, activityInformation}
};